const CREDENTIALS = [
  {
    title: "Education",
    text: "The Ohio State University · BS Environmental Science; Graduate Coursework in Civil & Environmental Engineering."
  },
  {
    title: "US Navy Seabees Veteran",
    text: "8 Years Naval Construction Force. Trained deep sea diver and underwater construction technician."
  },
  {
    title: "20 Years Principal",
    text: "Owner of Diamond V, LLC / Ohio Geomatics serving Central Ohio builders and landowners."
  },
  {
    title: "5 Years Executive VP",
    text: "Vice President, Columbus Engineering Consultants managing municipal civil design teams."
  }
];

const SECTORS = [
  { name: "Commercial & Retail:", detail: "Site layout, ALTA surveys, utility connections." },
  { name: "Residential Development:", detail: "Boundary platting, grading, stormwater ponds." },
  { name: "Energy & Industrial:", detail: "Transmission corridors, facility survey control." },
  { name: "Department of Defense & Transportation:", detail: "Federal specification compliance." }
];

export const Background = () => (
  <section id="background" className="py-24 bg-graphite text-white" data-testid="background-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <h2 className="text-xs font-bold uppercase tracking-widest text-amber-400 mb-2">Qualifications &amp; Heritage</h2>
          <p className="font-display text-3xl sm:text-4xl font-bold text-white mb-6">Steve Lamphear, PE, PS, RLS</p>
          <p className="text-stone-300 leading-relaxed mb-6 font-light">
            With 35 years of active professional practice across Central Ohio and federal jurisdictions, Steve Lamphear brings a rare dual-discipline depth: commanding both the physical precision of land boundary recovery and the analytical rigor of civil infrastructure design.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs text-stone-300">
            {CREDENTIALS.map((c) => (
              <div key={c.title} className="p-4 rounded bg-stone-900 border border-stone-800">
                <span className="block font-bold text-white mb-1">{c.title}</span>
                <span>{c.text}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="p-8 rounded-2xl bg-stone-900 border border-stone-800 text-stone-300">
            <h3 className="text-lg font-bold text-white mb-4">Sectors Served</h3>
            <ul className="space-y-3 text-xs leading-relaxed">
              {SECTORS.map((s) => (
                <li key={s.name} className="flex items-start gap-2">
                  <span className="text-amber-400 font-bold">▪</span>
                  <span><strong className="text-white">{s.name}</strong> {s.detail}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
);
